/**
 * BOOK'S ONE MONEY RULE (Web Director, 2026-10-31, after the Dev re-check):
 * a whole amount shows without cents ("$20", "$60"), any other with them
 * ("$12.50"), in the reader's locale. Spanish is US Spanish here: US dollars
 * and US separators ("$1,234.56"), as the service prices always were. Every
 * money display goes through this one function: fmt.money (prices, the
 * outcome's facts, /a's allocation rows) and formatMinorUnits (the payment
 * amounts).
 *
 * `minor` is in the currency's MINOR units; the exponent comes from Intl, so
 * a zero-decimal currency is not divided by 100. Throws on a currency Intl
 * does not know (formatMinorUnits catches).
 */
export function formatAmount(minor: number, currency: string, locale: string): string {
  const intl = locale === "es" ? "es-US" : locale;
  const digits = new Intl.NumberFormat(intl, { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
  const scale = 10 ** digits;
  const shown = minor % scale ? digits : 0;
  return new Intl.NumberFormat(intl, { style: "currency", currency, minimumFractionDigits: shown, maximumFractionDigits: shown }).format(minor / scale);
}
